/**
 * Monte custom sort dropdown
 *
 * Reemplaza el <select> nativo de "Ordenar por" por un dropdown estilizado.
 * El select original se mantiene oculto y se actualiza al hacer una seleccion,
 * disparando el evento change para que Dawn (facet-filters-form) reaccione.
 */

(function () {
  function buildDropdown(select) {
    if (!select || select.dataset.monteDropdownReady === 'true') return;
    select.dataset.monteDropdownReady = 'true';

    // Wrapper.
    const wrap = document.createElement('div');
    wrap.className = 'monte-sort';
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);

    // Trigger button.
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'monte-sort__trigger';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="monte-sort__label"></span>' +
      '<span class="monte-sort__caret" aria-hidden="true">' +
      '<svg viewBox="0 0 12 8" width="12" height="8"><path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round"/></svg>' +
      '</span>';
    wrap.appendChild(btn);

    // Options panel.
    const panel = document.createElement('ul');
    panel.className = 'monte-sort__panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    wrap.appendChild(panel);

    const renderOptions = () => {
      panel.innerHTML = '';
      Array.from(select.options).forEach((opt) => {
        const li = document.createElement('li');
        li.className = 'monte-sort__option';
        li.setAttribute('role', 'option');
        li.dataset.value = opt.value;
        li.textContent = opt.textContent;
        if (opt.selected) li.classList.add('is-active');
        li.addEventListener('click', () => {
          select.value = opt.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncLabel();
          panel.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        });
        panel.appendChild(li);
      });
    };

    const syncLabel = () => {
      const opt = select.options[select.selectedIndex];
      const lbl = btn.querySelector('.monte-sort__label');
      if (lbl && opt) lbl.textContent = opt.textContent;
      panel.querySelectorAll('.monte-sort__option').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.value === select.value);
      });
    };

    renderOptions();
    syncLabel();

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const willOpen = panel.hidden;
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }
    });

    // Si Dawn re-renderiza el select (despues de filtrar), refrescar opciones.
    new MutationObserver(() => {
      renderOptions();
      syncLabel();
    }).observe(select, { childList: true, attributes: true, attributeFilter: ['value'] });
  }

  function init() {
    // Solo en desktop. En mobile el select vive dentro del drawer de filtros y
    // Dawn lo maneja nativo. Reemplazarlo rompe la interaccion del drawer.
    if (window.matchMedia('(max-width: 749px)').matches) return;
    document
      .querySelectorAll('#SortBy, select[name="sort_by"]')
      .forEach(buildDropdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init cuando Dawn reemplace el contenedor de filtros tras un ajax.
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
